export const getFilter = state => state.productionSchedule.filter;

export default {
	getFilter,
};
